// Shared by the Nano Quest screens (employee and admin).

export const CATEGORY = {
  technical: 'Technical',
  health_safety: 'Health & Safety',
  values: 'Values',
  people: 'People',
  company: 'Company',
  participation: 'Participation',
};

export const CATEGORY_OPTIONS = Object.entries(CATEGORY).map(([value, label]) => ({ value, label }));

// "14 Oct" — on cards, where the year is obvious.
export const fmtShort = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }) : '');

// DD/MM/YYYY, everywhere else a person reads a date.
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-GB') : '');
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString('en-GB', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
}) : '');

// The tech server's message when it sent one; otherwise what to do about it.
export const errorText = (err, fallback) => err?.response?.data?.error
  || (err?.response ? fallback : 'Could not reach the server. Check your signal and try again.');

// "2026-Q4" -> "October – December 2026"; "2026" -> "2026".
// Spelled out, so nobody has to work out which months a quarter is.
const QUARTER_NAMES = ['January – March', 'April – June', 'July – September', 'October – December'];
export const periodLabel = (p) => {
  const m = /^(\d{4})-Q([1-4])$/.exec(p || '');
  return m ? `${QUARTER_NAMES[Number(m[2]) - 1]} ${m[1]}` : (p || '');
};

export const currentQuarter = (d = new Date()) => `${d.getUTCFullYear()}-Q${Math.floor(d.getUTCMonth() / 3) + 1}`;

// The last few quarters, newest first, for period pickers.
export function recentQuarters(count = 6) {
  const out = [];
  const d = new Date();
  let y = d.getUTCFullYear();
  let q = Math.floor(d.getUTCMonth() / 3) + 1;
  for (let i = 0; i < count; i += 1) {
    out.push(`${y}-Q${q}`);
    q -= 1;
    if (q === 0) { q = 4; y -= 1; }
  }
  return out;
}

const csvCell = (v) => {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// Saves rows as a CSV that opens in Excel. columns: [[header, row => value]].
export function downloadCsv(filename, columns, rows) {
  const lines = [columns.map(([h]) => csvCell(h)).join(',')]
    .concat(rows.map((r) => columns.map(([, get]) => csvCell(get(r))).join(',')));
  // BOM so Excel reads the £ and accents as UTF-8.
  const blob = new Blob([`﻿${lines.join('\r\n')}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
